<form>
  <h1 mat-dialog-title>{{ 'protocolEdit.dialog.essay.criteria.title' | translate }}</h1>

  <div mat-dialog-content class="air-theme">

    <div fxLayout="row" class="flexwrap">
      <div> 
        <mat-form-field class="campoFormulario">
          <mat-select name="criterias" required [(ngModel)]="data.criteria.idType"
            (selectionChange)="onCriteriaChange($event)">
            <mat-option>--</mat-option>
            @for (item of criterias; track item) {
            <mat-option [value]="item.id">
              {{ 'protocolEdit.dialog.essay.criteria.' + item.translation + '.label' | translate: {unit: data.unit} }}
            </mat-option>
            }
          </mat-select>
          <mat-error>
            {{ 'protocolEdit.dialog.essay.criteria.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      @if (criteriaSelected != null && criteriaSelected.variablesToShow >= 1) {
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.criteria.criteriaValue1.label' | translate }}</mat-label>
          <input matInput [name]="'criteriaValue1'" [(ngModel)]="data.criteria.criteriaValue1" required type="number"
            [disabled]="data.disabled">
          <mat-error>
            {{ 'protocolEdit.dialog.essay.criteria.criteriaValue1.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      }
      @if ((criteriaSelected != null && criteriaSelected.variablesToShow >= 2)) {
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.criteria.criteriaValue2.label' | translate }}</mat-label>
          <input matInput [name]="'criteriaValue2'" [(ngModel)]="data.criteria.criteriaValue2" required type="number"
            [disabled]="data.disabled">
          <mat-error>
            {{ 'protocolEdit.dialog.essay.criteria.criteriaValue2.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      }
      @if (showCriteriaCustomSubValue()) {
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-select name="mapCustomValues" required [ngModel]="data.criteria.customValue1" [disabled]="getTotalSubvalues() === 1"
            (selectionChange)="onCriteriaCustomSubValueChange($event)">
            @for (group of getCustomValues(); track group) {
            <mat-optgroup
              label="{{ 'protocolEdit.dialog.essay.criteria.' + group.translation + '.label' | translate: {unit: data.unit} }}">
              @for (item of mapCustomValues.get(group); track item) {
              <mat-option [value]="item.value">
                {{ 'protocolEdit.dialog.essay.criteria.' + item.translation + '.label' | translate: {unit: data.unit} }}
              </mat-option>
              }
            </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }
    </div>
    @if (showParticleSize()) {
    <div fxLayout="row" class="flexwrap">
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-select name="getParticleSize" required [ngModel]="getParticleValue(0)" required
            (selectionChange)="onParticleValueChange($event, 0)">
            <mat-option>--</mat-option>
            @for (item of getParticleSize(); track item) {
            <mat-option [value]="item">
              {{ item + 'µm' }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-select name="getParticleSize2" required [ngModel]="getParticleValue(1)" required
            (selectionChange)="onParticleValueChange($event, 1)">
            <mat-option>--</mat-option>
            @for (item of getParticleSize(); track item) {
            <mat-option [value]="item">
              {{ item + 'µm' }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (showThirdParticleSize()) {
        <div fxFlex>
          <mat-form-field class="campoFormulario">
            <mat-select name="getParticleSize3" required [ngModel]="getParticleValue(2)" required
              (selectionChange)="onParticleValueChange($event, 2)">
              <mat-option>--</mat-option>
              @for (item of getParticleSize(); track item) {
                <mat-option [value]="item">
                  {{ item + 'µm' }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
    }
    @if (showCustomText()) {
    <div fxLayout="row" class="flexwrap">
      @if (showCustomText1()) {
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.' + getCustomText1() + '.label' | translate }}</mat-label>
          <input matInput name="customText1" [(ngModel)]="data.criteria.customValue1" required>
        </mat-form-field>
      </div>
      }
      @if (showCustomText2()) {
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.' + getCustomText2() + '.label' | translate }}</mat-label>
          <input matInput name="customText2" [(ngModel)]="data.criteria.customValue2" required>
        </mat-form-field>
      </div>
      }
    </div>
    }
    @if (isAnexoI) {
    <div fxLayout="row">
      @if (textOneParticleAnexI || isTextOneAnexI) {
      <div fxFlex="100">
        @if (textOneParticleAnexI) {
        <div fxFlex="100" style="margin: auto;">
          <span>{{textOneParticleAnexI}}</span>
        </div>
        }
        @if (isTextOneAnexI) {
        <div fxFlex="100">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ (isMinParticleAnexI ? 'protocolEdit.dialog.essay.particleMinAnexI.label' :
              'protocolEdit.dialog.essay.particleMaxAnexI.label') | translate }}</mat-label>
            <input matInput name="customText1" [(ngModel)]="valueCriteria1" required>
          </mat-form-field>
        </div>
        }
      </div>
      }
      @if (textTwoParticleAnexI || isTextTwoAnexI) {
      <div fxFlex="100">
        @if (textTwoParticleAnexI) {
        <div fxFlex="100" style="margin: auto;">
          <span>{{textTwoParticleAnexI}}</span>
        </div>
        }
        @if (isTextTwoAnexI) {
        <div fxFlex="100">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ (isMaxParticleAnexI ? 'protocolEdit.dialog.essay.particleMaxAnexI.label' :
              'protocolEdit.dialog.essay.particleMinAnexI.label') | translate }}</mat-label>
            <input matInput name="customText2" [(ngModel)]="valueCriteria2" required>
          </mat-form-field>
        </div>
        }
      </div>
      }
    </div>
    }

    <br />

    @if (data.isEdit && data.criteria.fromProtocol) {
    <div fxLayout="row">
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.criteria.cols.criteria' | translate }} {{
            'common.inProtocol' |
            translate }}</mat-label>
          <mat-select name="idTypeProtocol" required [ngModel]="data.criteria.idTypeProtocol" name="criteriasProtocol" disabled>
            @for (item of criterias; track item) {
            <mat-option [value]="item.id">
              {{ 'protocolEdit.dialog.essay.criteria.' + item.translation + '.label' | translate }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (showCriteriaCustomSubValue()) {
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-select required [ngModel]="data.criteria.customValue1Protocol" [disabled]="true">
            @for (group of getCustomValues(); track group) {
            <mat-optgroup
              label="{{ 'protocolEdit.dialog.essay.criteria.' + group.translation + '.label' | translate }}">
              @for (item of mapCustomValues.get(group); track item) {
              <mat-option [value]="item.value">
                {{ 'protocolEdit.dialog.essay.criteria.' + item.translation + '.label' | translate }}
              </mat-option>
              }
            </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }
      <div fxFlex [hidden]="criteriaSelectedProtocol?.variablesToShow >= 1"></div>
      <div fxFlex [hidden]="criteriaSelectedProtocol?.variablesToShow < 1">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.criteria.criteriaValue1.label' | translate }} {{ 'common.inProtocol'
            | translate }}</mat-label>
          <input matInput [name]="'criteriaValueProtocol1'" [(ngModel)]="data.criteria.criteriaValueProtocol1" required
            [errorStateMatcher]="matcher" type="number" disabled>
        </mat-form-field>
      </div>
      <div fxFlex [hidden]="criteriaSelectedProtocol?.variablesToShow >= 2"></div>
      <div fxFlex [hidden]="criteriaSelectedProtocol?.variablesToShow < 2">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.criteria.criteriaValue2.label' | translate }} {{ 'common.inProtocol'
            | translate }}</mat-label>
          <input matInput [name]="'criteriaValueProtocol2'" [(ngModel)]="data.criteria.criteriaValueProtocol2" required
            [errorStateMatcher]="matcher" type="number" disabled>
        </mat-form-field>
      </div>
    </div>
    }

    <div fxLayout="column" class="flexwrap">
      <div fxFlex="100">
        <mat-checkbox name="showDiffInDeviations" [(ngModel)]="data.criteria.showDiffInDeviations">
          {{ 'executionEdit.sensorConfig.showDiffInDeviations.label' | translate }}
        </mat-checkbox>
      </div>
      <div fxFlex="100">
        <mat-checkbox name="showDiffInObservations" [(ngModel)]="data.criteria.showDiffInObservations">
          {{ 'executionEdit.sensorConfig.showDiffInObservations.label' | translate }}
        </mat-checkbox>
      </div>
    </div>

    <br />

    @if (showReason()) {
    <div fxLayout="column" class="flexwrap">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.dialog.confirmSave.reason.label' | translate }}</mat-label>
        <textarea name="reason" matInput [(ngModel)]="data.criteria.criteriaValueChangeReason" required></textarea>
        <mat-error>
          {{ 'protocolEdit.instrumentationUse.validator.reason.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    }
  </div>

  <div mat-dialog-actions align="end" class="air-theme">
    <button mat-raised-button color="primary" (click)="onOkClick()">
      {{ 'button.save' | translate }} </button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>
</form>